<wiz-vgroup padding="10px" width="100%" height="100%" class="section-container">
  <wiz-hgroup width="100%">
    <wiz-label [wizLabel]="'$.widget.configure.useraccess.$'" width="100%" class="smallTitleLabel"></wiz-label>
    <wiz-icon class="image-purple" (click)="hide()">close</wiz-icon>
  </wiz-hgroup>

  <wiz-hgroup width="100%">
    <wiz-checkbox [wizLabel]="'$.common.hidden.$'" [wizChecked]='isHidden' (wizClick)="setHidden($event)"></wiz-checkbox>
    <wiz-spacer width="10px"></wiz-spacer>
    <wiz-label [wizLabel]="'$.widget.target.place.$'" class="sameAsLabel"></wiz-label>
    <wiz-text-input #tiTargetPlace wizShowLabel="false" [wizValue]='targetPlace' width="160px" >
    </wiz-text-input>
  </wiz-hgroup>

  <wiz-checkbox [wizLabel]="'$.widget.show.liste.$'" [wizChecked]='showList' (wizClick)="setShowList($event)"></wiz-checkbox>
  <wiz-checkbox [wizLabel]="'$.widget.show.add.$'" [wizChecked]='showAdd' (wizClick)="setShowAdd($event)"></wiz-checkbox>
  <wiz-checkbox [wizLabel]="'$.widget.show.delete.$'" [wizChecked]='showDelete' (wizClick)="setShowDelete($event)"></wiz-checkbox>
  <wiz-checkbox [wizLabel]="'$.widget.gatling.mode.$'" 
  [visible]="isGatlingEnable"
  [wizChecked]='isGatlingMode' (wizClick)="setGatlingMode($event)"></wiz-checkbox>


  <wiz-checkbox [wizLabel]="'$.widget.no.user.filter.$'" [wizChecked]='noUserFilter' (wizClick)="setNoUserFilter($event)"></wiz-checkbox>

  <wiz-checkbox [wizLabel]="'$.widget.configure.useraccess.no.$'" [wizChecked]='lockSettings' (wizClick)="setLockSettings($event)"></wiz-checkbox>
  <wiz-checkbox [wizLabel]="'$.widget.configure.useraccess.edition.lock.$'" [wizChecked]='lockEdition' (wizClick)="setLockEdition($event)"></wiz-checkbox>
  
  <wiz-checkbox [wizLabel]="'$.widget.configure.useraccess.headermassedit.$'" 
  [visible]="isMassEditVisible" [wizChecked]='headerMassEdit' (wizClick)="setHeaderMassEdit($event)"></wiz-checkbox>

  <wiz-checkbox [wizLabel]="'$.pivot.delete.lines.title.$'" 
  [visible]="isMassDeleteVisible" [wizChecked]='massDelete' (wizClick)="setMassDelete($event)"></wiz-checkbox>
 
  <wiz-checkbox [wizLabel]="'$.widget.configure.useraccess.excel.update.$'" style="padding-left: 10px;" 
  [visible]="isExcelVisible" [wizChecked]='excelUpdate' (wizClick)="setExcelUpdate($event)"></wiz-checkbox>
  <wiz-checkbox [wizLabel]="'$.widget.configure.useraccess.excel.create.$'" style="padding-left: 10px;" 
  [visible]="isExcelVisible" [wizChecked]='excelCreate' (wizClick)="setExcelCreate($event)"></wiz-checkbox>

  <wiz-checkbox [wizLabel]="'$.widget.configure.useraccess.excel.nonuniqueshort.$'" style="padding-left: 10px;" 
  [visible]="isExcelFreedata" [wizChecked]='excelNonUniqueShortCode' (wizClick)="setExcelNonUniqueShortCode($event)"></wiz-checkbox>

  <wiz-hgroup [visible]="isExcelVisible" style="padding-left: 10px;">
    <wiz-label [wizLabel]="'$.excel.drop.sheetname.$'" class="sameAsLabel"></wiz-label>
    <wiz-text-input #tiExcelSheet wizShowLabel="false" [wizValue]='excelSheetName' width="160px" >
    </wiz-text-input>
  </wiz-hgroup>

  <wiz-checkbox [wizLabel]="'$.widget.noexport.excel.$'"
  [wizChecked]='exportXLS' (wizClick)="setExportXLS($event)"></wiz-checkbox>
  <wiz-checkbox [wizLabel]="'$.widget.noexport.pdf.$'"
  [wizChecked]='exportPDF' (wizClick)="setExportPDF($event)"></wiz-checkbox>


  <wiz-checkbox [wizLabel]="'$.widget.configure.useraccess.showfilters.$'" [visible]="isVisible" [wizChecked]='showFilters' (wizClick)="setShowFilters($event)"></wiz-checkbox>
  
  <wiz-checkbox [wizLabel]="'$.scen.activate.$'" 
  [visible]="visionScenActive" 
  [wizChecked]='useScenarii' 
  (wizClick)="setUseScenarii($event)"></wiz-checkbox>


  <wiz-checkbox [wizLabel]="'$.scen.concurrent.$'" style="padding-left: 10px;"
  [visible]="scenActive" 
  [wizChecked]='useMultipleScenarii' 
  (wizClick)="setMultipleScenarii($event)"></wiz-checkbox>
  
  <wiz-checkbox [wizLabel]="'$.scen.user.enable.$'" style="padding-left: 10px;" 
  [visible]="scenActiveSolo" 
  [wizChecked]='useUserShowScenarii' 
  (wizClick)="setUserShowScenarii($event)"></wiz-checkbox>

  <wiz-checkbox [wizLabel]="'$.scen.show.label.$'" style="padding-left: 10px;" 
  [visible]="scenActiveSolo" 
  [wizChecked]='useShowScenLabel' 
  (wizClick)="setShowScenLabel($event)"></wiz-checkbox>

  <wiz-hgroup width="100%" height="100%" horizontalAlign="end" verticalAlign="end">
    <wiz-button wizLabel="$.common.validate.$" (wizClick)="onSave()"></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
